import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Replace with your actual Google Analytics tracking ID
const TRACKING_ID = "G-2RJ1SHBXBF"; // Replace with your GA measurement ID

const GoogleAnalytics = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Initialize Google Analytics script
    const addGoogleAnalyticsScript = () => {
      // Skip if already initialized or in development
      if (window.ga || process.env.NODE_ENV !== 'production') return;
      
      // Create script elements
      const gaScript = document.createElement('script');
      gaScript.async = true;
      gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${TRACKING_ID}`;
      
      const gaConfig = document.createElement('script');
      gaConfig.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${TRACKING_ID}', { page_path: window.location.pathname });
      `;
      
      // Append to document
      document.head.appendChild(gaScript);
      document.head.appendChild(gaConfig);
    };
    
    addGoogleAnalyticsScript();
  }, []);
  
  useEffect(() => {
    // Track page changes
    if (window.gtag && process.env.NODE_ENV === 'production') {
      window.gtag('config', TRACKING_ID, { page_path: location.pathname + location.search });
    }
  }, [location]);
  
  return null;
};

export default GoogleAnalytics;